import { BranchState } from 'common/types/entities/branch'
import { StateKey } from 'common/utils/flipState'
import { fetchWindowBranch } from '../../services/branch'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

export const initialState: BranchState = {
  _id: '',
  parentId: '',
  name: '',
  used: false,
  order: 0,
  exposureText: '',
  alias: '',
  subVerticals: [],
  type: null,
  wholeIds: [],
  createdAt: null,
  updatedAt: null,
  business: null,
  images: [],
  slogan: null,
  branchList: [],
  cacheParam: null,
}

const FETCH = '/branch/FETCH'

export const fetchBranch = (curState: StateKey, id: string) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'fetchBranch', { curState, id })
  if (isCacheHit(getState().branch[curState], cacheParam)) {
    return
  }

  const result = await fetchWindowBranch(id)

  dispatch({
    curState,
    cacheParam,
    result,
    type: FETCH,
  })
}

const branchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        cacheParam: action.cacheParam,
        ...action.result,
      }
    default:
      return state
  }
}

export default branchReducer
